import http from "../plugins/axios";

const getVacanciesApiCall = async (
    params,
    abortController = null,
) => {
    const { data } = await http.get('/api/company/v3/vacancies', { signal: abortController?.signal, params: params })
    return data
}
const getDepartmentsVacanciesApiCall = async (
    params,
    abortController = null,
) => {
    const { data } = await http.get('/api/company/v3/vacancies/departments/dropdown', { signal: abortController?.signal, params: params })
    return data
}
const getLocationsVacanciesApiCall = async (
    params,
    abortController = null,
) => {
    const { data } = await http.get('/api/company/v3/vacancies/locations/dropdown', { signal: abortController?.signal, params: params })
    return data
}
const getVacanciesItemApiCall = async (
    params,
    abortController = null,
) => {
    const { data } = await http.get(`/api/company/v3/vacancies/${params.id}`, { signal: abortController?.signal })
    return data
}

const createVacanciesApiCall = async (
    params,
    abortController = null,
) => {
    const { data } = await http.post('/api/company/v3/vacancies',
        { ...params },
        { signal: abortController?.signal })
    return data
}

const updateVacanciesApiCall = async (
    params,
    abortController = null,
) => {
    const { data } = await http.patch(`/api/company/v3/vacancies/${params.id}`,
        { ...params.data },
        { signal: abortController?.signal })
    return data
}

const deleteVacanciesApiCall = async (
    params,
    abortController = null,
) => {
    const { data } = await http.delete(`/api/company/v3/vacancies/${params.id}`,
        { signal: abortController?.signal })
    return data
}

const getLocationsApiCall = async (
    params,
    abortController = null,
) => {
    const { data } = await http.get('/api/company/v3/vacancies/locations', { signal: abortController?.signal, params: params })
    return data
}


const createLocationsApiCall = async (
    params,
    abortController = null,
) => {
    const { data } = await http.post('/api/company/v3/vacancies/locations',
        { ...params },
        { signal: abortController?.signal })
    return data
}

const updateLocationsApiCall = async (
    params,
    abortController = null,
) => {
    const { data } = await http.patch(`/api/company/v3/vacancies/locations/${params.id}`,
        { ...params.data },
        { signal: abortController?.signal })
    return data
}

const deleteLocationsApiCall = async (
    params,
    abortController = null,
) => {
    const { data } = await http.delete(`/api/company/v3/vacancies/locations/${params.id}`,
        { signal: abortController?.signal })
    return data
}

const getDepartmentsApiCall = async (
    params,
    abortController = null,
) => {
    const { data } = await http.get('/api/company/v3/vacancies/departments', { signal: abortController?.signal, params: params })
    return data
}

const createDepartmentsApiCall = async (
    params,
    abortController = null,
) => {
    const { data } = await http.post('/api/company/v3/vacancies/departments',
        { ...params },
        { signal: abortController?.signal })
    return data
}

const updateDepartmentsApiCall = async (
    params,
    abortController = null,
) => {
    const { data } = await http.patch(`/api/company/v3/vacancies/departments/${params.id}`,
        { ...params.data },
        { signal: abortController?.signal })
    return data
}

const deleteDepartmentsApiCall = async (
    params,
    abortController = null,
) => {
    const { data } = await http.delete(`/api/company/v3/vacancies/departments/${params.id}`,
        { signal: abortController?.signal })
    return data
}


export {
    getVacanciesApiCall,
    getVacanciesItemApiCall,
    createVacanciesApiCall,
    updateVacanciesApiCall,
    deleteVacanciesApiCall,
    getDepartmentsVacanciesApiCall,
    getLocationsVacanciesApiCall,
    createLocationsApiCall,
    updateLocationsApiCall,
    deleteLocationsApiCall,
    createDepartmentsApiCall,
    updateDepartmentsApiCall,
    deleteDepartmentsApiCall,
    getDepartmentsApiCall,
    getLocationsApiCall,
};